import { Label } from '@components/ui/label';
import { Switch } from '@components/ui/switch';
import {
  FormControl as MuiFormControl,
  FormLabel as MuiFormLabel,
  Switch as MuiSwitch,
  switchClasses as MuiSwitchClasses,
  type SwitchProps as MuiSwitchProps
} from '@mui/joy';
import type * as SwitchPrimitives from '@radix-ui/react-switch';
import type { ReactNode } from 'react';

interface SwitchFieldProps extends MuiSwitchProps {
  label?: ReactNode;
  title?: string;
}
/** @deprecated */
export const SwitchField = (props: SwitchFieldProps) => (
  <div>
    {props.title && (
      <MuiFormControl size={props.size || 'sm'}>
        <MuiFormLabel required={props.required}>{props.title}</MuiFormLabel>
      </MuiFormControl>
    )}
    <MuiSwitch
      endDecorator={props.label}
      size={'sm'}
      sx={{
        [`& .${MuiSwitchClasses.thumb}`]: {
          transition: 'left 0.2s',
          width: 14,
          height: 14
        }
      }}
      {...props}
    />
  </div>
);

type SwitchV2Props = React.ComponentPropsWithoutRef<
  typeof SwitchPrimitives.Root
> & {
  id: string;
  labelText: string;
  tooltip?: ReactNode;
};
export const SwitchV2 = ({ labelText, tooltip, ...props }: SwitchV2Props) => (
  <div className="flex select-none items-center space-x-2">
    <Switch {...props} />
    <Label className="cursor-pointer font-normal text-sm" htmlFor={props.id}>
      {labelText}
    </Label>
    {tooltip}
  </div>
);
